interface ChallengeStatsCardProps {
  icon: string;
  label: string;
  value: string;
  highlighted?: boolean;
}

export function ChallengeStatsCard({
  icon,
  label,
  value,
  highlighted = false,
}: ChallengeStatsCardProps) {
  const glowStyle = highlighted
    ? {
        boxShadow: "0 0 12px 1px #0df20d, 0 0 20px 2px #0df20d20",
        borderColor: "rgba(13, 242, 13, 0.5)",
        borderWidth: "1px",
      }
    : undefined;

  return (
    <div
      className="flex flex-col gap-2 rounded-4xl bg-black/5 dark:bg-white/5 p-4"
      style={glowStyle}
    >
      <span className="material-symbols-outlined text-primary">
        {icon}
      </span>
      <p className="text-sm font-medium text-content-light/70 dark:text-content-dark/70">{label}</p>
      <p
        className={`text-xl font-bold ${highlighted ? 'text-primary' : 'text-content-light dark:text-content-dark'}`}
      >
        {value}
      </p>
    </div>
  );
}
